<project-navigation
  [headerTitle]="'projectNavigation.cae_export_title'"
  [headerText]="'projectNavigation.cae_export_message'"
  [model]="model"
  [submitEnabled]="submitEnabled"
  [visibleFeatures]="{
    compositeCheckBox: false,
    pinnedProjects: true,
    recentlyUsedProjects: true,
    history: true,
    projectActionsMenu: false,
    projectGroupContextMenu: true,
    newConfigurationGroupBtn: false,
    newFolderBtn: false,
    dialogSearch: true,
    tabs: true,
    breadcrumbs: true,
  }"
  [actionButtonLabel]="'importExportProject.export.button.label'"
  (submitEnabledChanged)="updateSubmitEnabled()"
  (actionBtnClick)="initializeCaeExport()"
  (cancel)="cancel()"
></project-navigation>
